import RelocateDayModal from './RelocateDayModal';

export default RelocateDayModal;
